export default "__VITE_PUBLIC_ASSET__50831fd7__"